import { render, staticRenderFns } from "./BackofficeProcedimento.vue?vue&type=template&id=6d9debb6&scoped=true"
import script from "./BackofficeProcedimento.vue?vue&type=script&lang=ts"
export * from "./BackofficeProcedimento.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeProcedimento.vue?vue&type=style&index=0&id=6d9debb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9debb6",
  null
  
)

export default component.exports